import React, { useState } from "react";
import Layout from "./../components/Layout/Layout";
import { useCart } from "../context/cart";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import "../styles/CartStyles.css";

const CartPage = () => {
  const [cart, setCart] = useCart();
  const [loading, setLoading] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("cash_on_delivery");
  const [form, setForm] = useState({
    name: "",
    phone: "",
    city: "",
    address: "",
    notes: "",
  });
  const navigate = useNavigate();

  const totalPrice = () => {
    try {
      let total = 0;
      cart?.forEach((item) => {
        total = total + item.price;
      });
      return total.toLocaleString("ar-IQ") + " د.ع";
    } catch (error) {
      console.log(error);
    }
  };

  const removeCartItem = (pid) => {
    try {
      let myCart = [...cart];
      let index = myCart.findIndex((item) => item._id === pid);
      myCart.splice(index, 1);
      setCart(myCart);
      localStorage.setItem("cart", JSON.stringify(myCart));
      toast.success("تم إزالة المنتج من السلة");
    } catch (error) {
      console.log(error);
    }
  };

  const handleOrder = async () => {
    if (!form.name || !form.phone || !form.city || !form.address) {
      toast.error("يرجى ملء جميع الحقول المطلوبة");
      return;
    }

    try {
      setLoading(true);
      const { data } = await axios.post("/api/v1/payments/initiate", {
        ...form,
        paymentMethod,
        cart: cart.map(p => ({ _id: p._id, quantity: 1 })),
      });
      setLoading(false);

      if (data?.success) {
        // Qi online payment → redirect to Qi payment page
        if (data.payment?.paymentUrl) {
          localStorage.removeItem("cart");
          setCart([]);
          window.location.href = data.payment.paymentUrl;
          return;
        }

        // Cash on delivery → show success
        localStorage.removeItem("cart");
        setCart([]);
        setOrderSuccess({
          orderId: data.payment?.orderId,
          invoiceNumber: data.payment?.invoiceNumber,
          accessToken: data.payment?.accessToken,
          totalAmount: data.payment?.totalAmount,
          paymentMethod: data.payment?.paymentMethod,
        });
        toast.success("تم تأكيد طلبك بنجاح!");
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      const msg = error.response?.data?.message || "حدث خطأ، يرجى المحاولة مرة أخرى";
      toast.error(msg);
    }
  };

  // Build WhatsApp message
  const getWhatsAppLink = () => {
    const items = cart.map(p => `• ${p.name} - ${p.price.toLocaleString("ar-IQ")} د.ع`).join('\n');
    const msg = `طلب جديد\n\nالاسم: ${form.name}\nالهاتف: ${form.phone}\nالمحافظة: ${form.city}\nالعنوان: ${form.address}\n\nالمنتجات:\n${items}\n\nالمجموع: ${totalPrice()}\n\nملاحظات: ${form.notes || 'لا يوجد'}`;
    return `https://wa.me/971542237463?text=${encodeURIComponent(msg)}`;
  };

  // Share payment link handler
  const handleSharePayLink = () => {
    if (!orderSuccess?.accessToken) return;
    const payUrl = `${window.location.origin}/pay/${orderSuccess.accessToken}`;
    if (navigator.share) {
      navigator.share({
        title: `دفع طلب ${orderSuccess.orderId}`,
        text: `رابط دفع طلب من النخبة ستور`,
        url: payUrl,
      }).catch(() => {});
    } else {
      navigator.clipboard?.writeText(payUrl);
      toast.success("تم نسخ رابط الدفع");
    }
  };

  // Order success view
  if (orderSuccess) {
    return (
      <Layout title="تم الطلب بنجاح - النخبة ستور">
        <div className="cart-page">
          <div className="container">
            <div className="empty-state" style={{marginTop: '60px'}}>
              <div className="empty-state-icon">✅</div>
              <h4>تم استلام طلبك بنجاح!</h4>
              <p>رقم الطلب: <strong>{orderSuccess.orderId}</strong></p>
              {orderSuccess.invoiceNumber && (
                <p>رقم الفاتورة: <strong>{orderSuccess.invoiceNumber}</strong></p>
              )}
              <p style={{color: 'var(--white-muted)'}}>سنتواصل معك قريباً لتأكيد الطلب</p>
              <div style={{display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap', marginTop: '20px'}}>
                {orderSuccess.accessToken && (
                  <button className="btn btn-gold-shimmer" onClick={() => navigate(`/invoice/${orderSuccess.accessToken}`)}>
                    عرض الفاتورة
                  </button>
                )}
                {orderSuccess.accessToken && (
                  <button
                    className="btn"
                    onClick={handleSharePayLink}
                    style={{background: '#0088cc', color: '#fff', fontWeight: '600', borderRadius: '10px', padding: '8px 20px'}}
                  >
                    مشاركة رابط الدفع
                  </button>
                )}
                <button className="btn btn-gold-shimmer" onClick={() => navigate('/')} style={{background: 'transparent', border: '1px solid var(--gold)'}}>
                  متابعة التسوق
                </button>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title="سلة التسوق - النخبة ستور">
      {/* Hero */}
      <div className="categories-hero" style={{height: '180px', minHeight: '180px'}}>
        <img src="/images/logo2.jpeg" alt="النخبة ستور" className="categories-hero-bg" />
        <div className="categories-hero-overlay">
          <h1>سلة التسوق</h1>
          <p>اطلب مباشرة بدون تسجيل</p>
        </div>
      </div>

      <div className="cart-page">
        <div className="container">
          {/* Cart Status */}
          <div className="cart-status-bar">
            <p>
              {cart?.length
                ? `لديك ${cart.length} منتج في سلة التسوق`
                : "سلة التسوق فارغة"}
            </p>
          </div>

          {cart?.length > 0 ? (
            <div className="row">
              {/* Cart Items */}
              <div className="col-md-7">
                {cart?.map((p, index) => (
                  <div className="cart-item glass-card" key={`${p._id}-${index}`} style={{animationDelay: `${index * 0.06}s`}}>
                    <div className="cart-item-img">
                      <img
                        src={`/api/v1/products/product-photo/${p._id}`}
                        alt={p.name}
                        loading="lazy"
                      />
                    </div>
                    <div className="cart-item-info">
                      <h5 className="cart-item-name">{p.name}</h5>
                      <p className="cart-item-desc">{p.description.substring(0, 40)}...</p>
                      <p className="cart-item-price">{p.price.toLocaleString("ar-IQ")} د.ع</p>
                    </div>
                    <div className="cart-item-actions">
                      <button
                        className="cart-remove-btn"
                        onClick={() => removeCartItem(p._id)}
                        title="إزالة"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              {/* Cart Summary + Order Form */}
              <div className="col-md-5">
                <div className="cart-summary glass-card">
                  <h3 className="cart-summary-title">ملخص الطلب</h3>
                  <div className="cart-summary-divider"></div>

                  <div className="cart-summary-row">
                    <span>عدد المنتجات</span>
                    <span>{cart?.length}</span>
                  </div>
                  <div className="cart-summary-row cart-summary-total">
                    <span>المجموع الكلي</span>
                    <span>{totalPrice()}</span>
                  </div>

                  <div className="cart-summary-divider"></div>

                  {/* Direct Order Form */}
                  <div className="cart-address-section">
                    <h6 style={{color: 'var(--gold)', marginBottom: '15px'}}>📋 معلومات التوصيل</h6>

                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="الاسم الكامل *"
                        value={form.name}
                        onChange={(e) => setForm({...form, name: e.target.value})}
                        style={{background: 'var(--black-soft)', border: 'var(--border-gold)', color: 'var(--white)', direction: 'rtl'}}
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="رقم الهاتف *"
                        value={form.phone}
                        onChange={(e) => setForm({...form, phone: e.target.value})}
                        style={{background: 'var(--black-soft)', border: 'var(--border-gold)', color: 'var(--white)', direction: 'rtl', textAlign: 'right'}}
                      />
                    </div>
                    <div className="mb-3">
                      <select
                        className="form-select"
                        value={form.city}
                        onChange={(e) => setForm({...form, city: e.target.value})}
                        style={{background: 'var(--black-soft)', border: 'var(--border-gold)', color: 'var(--white)', direction: 'rtl'}}
                      >
                        <option value="">اختر المحافظة *</option>
                        <option value="بغداد">بغداد</option>
                        <option value="البصرة">البصرة</option>
                        <option value="نينوى">نينوى</option>
                        <option value="اربيل">اربيل</option>
                        <option value="النجف">النجف</option>
                        <option value="كربلاء">كربلاء</option>
                        <option value="السليمانية">السليمانية</option>
                        <option value="ذي قار">ذي قار</option>
                        <option value="ديالى">ديالى</option>
                        <option value="الانبار">الانبار</option>
                        <option value="كركوك">كركوك</option>
                        <option value="بابل">بابل</option>
                        <option value="واسط">واسط</option>
                        <option value="صلاح الدين">صلاح الدين</option>
                        <option value="ميسان">ميسان</option>
                        <option value="المثنى">المثنى</option>
                        <option value="القادسية">القادسية</option>
                        <option value="دهوك">دهوك</option>
                      </select>
                    </div>
                    <div className="mb-3">
                      <textarea
                        className="form-control"
                        placeholder="العنوان التفصيلي *"
                        rows="2"
                        value={form.address}
                        onChange={(e) => setForm({...form, address: e.target.value})}
                        style={{background: 'var(--black-soft)', border: 'var(--border-gold)', color: 'var(--white)', direction: 'rtl', resize: 'vertical'}}
                      />
                    </div>
                    <div className="mb-3">
                      <textarea
                        className="form-control"
                        placeholder="ملاحظات (اختياري)"
                        rows="2"
                        value={form.notes}
                        onChange={(e) => setForm({...form, notes: e.target.value})}
                        style={{background: 'var(--black-soft)', border: 'var(--border-gold)', color: 'var(--white)', direction: 'rtl', resize: 'vertical'}}
                      />
                    </div>
                  </div>

                  {/* Payment Method Selection */}
                  <div className="mt-3">
                    <h6 style={{color: 'var(--gold)', marginBottom: '12px'}}>طريقة الدفع</h6>
                    <div style={{display: 'flex', gap: '10px', marginBottom: '15px'}}>
                      <button
                        type="button"
                        className={`btn w-50 ${paymentMethod === 'cash_on_delivery' ? 'btn-gold-shimmer' : ''}`}
                        style={paymentMethod !== 'cash_on_delivery' ? {background: 'var(--black-soft)', border: 'var(--border-gold)', color: 'var(--white)'} : {}}
                        onClick={() => setPaymentMethod('cash_on_delivery')}
                      >
                        الدفع عند الاستلام
                      </button>
                      <button
                        type="button"
                        className={`btn w-50 ${paymentMethod === 'qi' ? 'btn-gold-shimmer' : ''}`}
                        style={paymentMethod !== 'qi' ? {background: 'var(--black-soft)', border: 'var(--border-gold)', color: 'var(--white)'} : {}}
                        onClick={() => setPaymentMethod('qi')}
                      >
                        Qi Card كي كارد
                      </button>
                    </div>

                    <button
                      className="btn btn-gold-shimmer w-100"
                      onClick={handleOrder}
                      disabled={loading || !form.name || !form.phone || !form.city || !form.address}
                    >
                      {loading
                        ? "جاري المعالجة ...."
                        : paymentMethod === 'qi'
                          ? "الدفع عبر Qi Card"
                          : "تأكيد الطلب"}
                    </button>

                    <div style={{textAlign: 'center', margin: '12px 0', color: 'var(--white-muted)', fontSize: '0.85rem'}}>أو</div>

                    <a
                      href={getWhatsAppLink()}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn w-100"
                      style={{background: '#25D366', color: '#fff', fontWeight: '600', borderRadius: '10px', padding: '10px'}}
                    >
                      اطلب عبر واتساب
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="empty-state" style={{marginTop: '40px'}}>
              <div className="empty-state-icon">🛒</div>
              <h4>سلة التسوق فارغة</h4>
              <p>ابدأ بالتسوق وأضف المنتجات إلى سلتك</p>
              <button className="btn btn-gold-shimmer mt-3" onClick={() => navigate('/')}>
                تسوّق الآن
              </button>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default CartPage;
